import React, { Component } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import FrontNav from '../../../components/FrontNav';
import TabNav from '../../../components/TabNav';
import EventList from '../../../components/Activity/Event/EventList';

class ScreenEventsList extends Component {
	render () {
		return (
			<section>
				<Header />
				<FrontNav match={this.props.match} />
				<TabNav match={this.props.match} />
			    <EventList />
			    <Footer />
			</section>
		)
	}
}

export default ScreenEventsList;